export * from './headSpace';

import { Container, SxProps } from '@mui/material';
import { FC } from 'react';
import { Content } from './content';

/**
 * `<Page />` positions the content.
 *
 * `<Page />` is the base for every page.
 */

type Props = {
  contextMenu?: JSX.Element;
  sx?: SxProps;
  className?: string;
};

export const Page: FC<React.PropsWithChildren<Props>> = ({
  children,
  contextMenu,
  sx,
  className
}) => {
  return (
    <Container
      maxWidth="xl"
      sx={{
        height: '100%',
        paddingY: '32px',
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridAutoFlow: 'column',
        alignItems: 'flex-start',
        gridColumnGap: '3rem'
      }}
    >
      <Content sx={sx} className={className}>
        {children}
      </Content>
      {contextMenu && contextMenu}
    </Container>
  );
};
